<script lang="ts">
  import Skeleton from "../skeletons/Skeleton.svelte";

  export let columns = 5;
</script>

<div class="row">
  {#each Array(columns) as _}
    <div class="cell-gap cell divider">
      <Skeleton --skeleton-width="60px" --skeleton-height="10px" />
    </div>
  {/each}
</div>

<style>
  .row {
    display: contents;
  }

  .cell {
    height: 64px;
    display: flex;
    align-items: center;
  }

  .divider {
    border-bottom: 1px solid var(--rk-divider-0);
  }

  .cell-gap {
    padding-left: 12px;
    padding-right: 12px;
  }
</style>
